import {Observable} from 'rxjs';
import {Injectable} from "@angular/core";
import {CoreApiService} from "src/app/core/core-api.service";
import {endpoints} from "src/environments/endpoints";

@Injectable({
  providedIn: "root",
})
export class PerfilService {
  constructor(
    private apiService: CoreApiService
  ) {
  }

  listarEmpresas(documentoIdentificador: string) {
    let query = {
      documentoIdentificador,
    };

    return this.apiService.get(endpoints.listarEmpresas, {query});
  }

  listarEmpresa(cnpj: string, documentoIdentificador: string) {
    let query = {
      documentoIdentificador,
    };

    return this.apiService.get(`${endpoints.listarEmpresas}/${cnpj}`, {query});
  }

  consultaSolicitacoes() {

    return this.apiService.get(endpoints.listarSolicitações);
  }

  consultaDisponibilidadeEntidade(id) {
    return this.apiService.get(
      `${endpoints.garantiaDisponibilidadeEntidade}/${id}`
    );
  }

  consultaDisponibilidade(id) {
    return this.apiService.post(
      `${
        endpoints.garantiaDisponibilidade
      }/${id}`,
      {}
    );
  }

  acompanharProcessoSolicitacao(params = {}) {
    return this.apiService.get(`${endpoints.acompanharProcesso}`, {params});
  }

  consultaDisponibilidadeDPGE() {

    return this.apiService.get(`${endpoints.consultaDisponibilidadeDPGE}`, );
  }

  consultaDisponibilidadeGarantiaDPGE(id, cnpjEscolhidoGarantiaDPGE) {
    let params = {
      cnpjEmpresaEscolhidaCredor: cnpjEscolhidoGarantiaDPGE
    };

    return this.apiService.get(
      `${endpoints.verificarDisponibilidadeDPGE}/${id}`,
      {params}
    );
  }

  listarDadosUsuario(documentoIdentificador: string): Observable<any> {
    return this.apiService.get(`${endpoints.atualizarDados}`);
  }

  updateDadosUsuario(documentoIdentificador: string, body): Observable<any> {
    return this.apiService.put(`${endpoints.atualizarDados}`, body);
  }

  confirmarUpdate(documentoIdentificador: string): Observable<any> {
    return this.apiService.post(`${endpoints.atualizarCognito}`, {});
  }

  statusAndamentoAceite(id) {

    return this.apiService.get(`${endpoints.acompanharAceite}/${id}/pagamentos/termo/andamento-aceite`, {});
  }
}
